import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import type { WeekAvailability } from '../../../types/availability';
import { AvailabilityMatrix, Day, TimeGridEntry } from '../../AvailabilityMatrix/AvailabilityMatrix';
import { useTimetableStore } from '../../TimetableGrid/TimetableProvider';

const DAYS: Day[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

type ResourceAvailabilityMatrixProps = {
  /** The selected resource's availability edge properties (or undefined while loading / none selected). */
  availability: WeekAvailability | undefined;
  timeGridEntries: TimeGridEntry[];
  loading: boolean;
  fetching: boolean;
  onChange: (availability: WeekAvailability) => void;
  /** Re-fetch the matrix query after an edit. */
  execute: () => void;
};

/**
 * Shared presentational matrix for the per-resource availability wrappers (Teachers/Subjects/Rooms/
 * Classes). The wrappers differ only in the typed GraphQL query + edge path; everything below — the
 * weekday list, the pause filter, readonly wiring and the re-fetch-on-change — lived identically in
 * all four and now lives here once.
 */
export const ResourceAvailabilityMatrix = observer(
  ({ availability, timeGridEntries, loading, fetching, onChange, execute }: ResourceAvailabilityMatrixProps) => {
    const store = useTimetableStore();
    return (
      <AvailabilityMatrix
        days={DAYS}
        hours={timeGridEntries.filter((entry) => !entry.pause)}
        availability={availability}
        readonly={toJS(store.readonly) || fetching}
        loading={loading}
        onChange={(items) => {
          onChange(items);
          execute();
        }}
      />
    );
  },
);
